/**
 * Ask every mounted `useMembership()` to re-read membership from the
 * database immediately. Fired after a payment is confirmed server-side so a
 * paid member gets access without a reload or a sign-out/sign-in cycle.
 */
export function refreshMembership() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent("rt-membership-refresh"));
}
